export default __webpack_public_path__ + "static/contact-a53163c90a1be44a63c2358e07602bcb.jpg";